import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import AgeValidModal from './age-valid-modal';
import translations from '../../../translations/app-translations.json';

class AgeValidWrapper extends Component {
    constructor(props, context) {
        super(props, context);
        this.handleClick = this.handleClick.bind(this);
        this.preventClick = this.preventClick.bind(this);
        this.isUnder21 = this.isUnder21.bind(this);
        this.wrapWithModal = this.wrapWithModal.bind(this);
        this.state = { showAgeMinModal: false };
    }

    closeAgeMinModal() {
        this.setState({ showAgeMinModal: false });
    }

    handleClick(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.state.showAgeMinModal === false) {
            this.setState({ showAgeMinModal: true });
        }
    }

    // eslint-disable-next-line class-methods-use-this
    isUnder21() {
        let isAgeValid;

        if (this.props.user && this.props.user.id) {
            if (this.props.user.age_valid !== null) {
                isAgeValid = this.props.user.age_valid;
            }
        } else {
            const ageValid = sessionStorage.getItem('katapulk_age_valid');

            if (ageValid !== null) {
                isAgeValid = JSON.parse(ageValid);
            }
        }

        return isAgeValid;
    }

    // eslint-disable-next-line class-methods-use-this
    preventClick(e) {
        e.stopPropagation();
        e.preventDefault();
        toastr.error(translations[this.props.locale.currentLocale].error, translations[this.props.locale.currentLocale]['sorry-product-over-21']);
    }

    wrapWithModal() {
        return (
            <span>
                <span onClickCapture={this.handleClick}>
                    {this.props.children}
                </span>
                <AgeValidModal
                    show={this.state.showAgeMinModal}
                    onHide={() => this.closeAgeMinModal()}
                />
            </span>
        );
    }

    render() {
        if (this.props.productAgeValid !== true) {
            return (this.props.children);
        }

        const isAgeValid = this.isUnder21();

        if (isAgeValid === undefined) {
            return this.wrapWithModal();
        }

        return isAgeValid
            ? (this.props.children)
            : (<span onClickCapture={this.preventClick}>{this.props.children}</span>);
    }
}

const AgeValidWrapperConnector = connect((state) => ({
    anonymousUser: state.anonymousUser,
    user: state.user,
    locale: state.locale,
}))(AgeValidWrapper);

export default AgeValidWrapperConnector;



/** WEBPACK FOOTER **
 ** ./src/components/age-valid-wrapper/age-valid-wrapper.jsx
 **/